import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'app-wizard-thank-you',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="wizard-content">
            <div class="wizard-content__aside">
                <div class="wizard-content__sticky"></div>
            </div>
            <div class="wizard-content__main">
                <p>
                    Пакет документов для аттестации лаборатории был сформирован и отправлен на проверку нашему специалисту.
                    В ближайшее время мы свяжемся с вами.
                </p>
            </div>
        </div>
    `
})

export class ThankYouComponent {

}
